import { DISCOVERY_CREATOR_SORT_LABELS, DiscoveryCreatorSort } from 'types/creator-discovery';
import AiPoweredBadge from './AiPoweredBadge';

interface DiscoveryResultsSummaryProps {
    query: string;
    sort: DiscoveryCreatorSort;
    onSortToggle: () => void;
}

const DiscoveryResultsSummary = ({ query, sort, onSortToggle }: DiscoveryResultsSummaryProps) => {
    return (
        <div className="discovery-results-summary">
            <div className="discovery-results-summary__main">
                <div className="discovery-results-summary__query-wrap">
                    <p className="discovery-results-summary__query">&ldquo;{query}&rdquo;</p>
                </div>
                <div className="discovery-results-summary__actions">
                    <button
                        type="button"
                        className="discovery-results-summary__sort-btn"
                        onClick={onSortToggle}
                    >
                        <i className="ri-arrow-up-down-line" />
                        Sort: {DISCOVERY_CREATOR_SORT_LABELS[sort]}
                    </button>
                </div>
            </div>
            <div className="discovery-results-summary__wave" aria-hidden="true" />
        </div>
    );
};

export default DiscoveryResultsSummary;
